import React from 'react';
import Cropper from 'react-cropper';
import PropTypes from 'prop-types';
import { UploadedPhoto } from '../../prop-types';

import 'cropperjs/dist/cropper.css';
import '../../../../../stylesheets/common/cropper-custom.css';

import IU from '../../../_utils/img/img-utils';
import Spinner from '../../../_utils/spinner';

const { imgHelpers } = IU;

export default function ImageCropper({
  style,
  imageSrc,
  photo,
  curCrop,
  handleCropperZoom,
  handleCrop,
  cropperRef,
}) {
  if (!photo) {
    return null;
  }

  if (!curCrop) {
    return <Spinner style={style} />;
  }

  // The cropper
  return (
    <CropperWrapper>
      <Cropper
        key={`tweaker${photo.imageId}`}
        id={`tweaker${photo.imageId}`}
        ref={cropperRef}
        style={style}
        src={imageSrc}
        alt="editor"
        data={curCrop}
        aspectRatio={imgHelpers.getPhotoAspectRatio(photo)}
        viewMode={2} // the crop box should be within the canvas
        dragMode="move"
        toggleDragModeOnDblclick={false}
        background={false}
        autoCropArea={1}
        minCropBoxWidth={1}
        minCropBoxHeight={1}
        crop={handleCrop}
        zoom={handleCropperZoom}
      />
    </CropperWrapper>
  );
}

export const CropperWrapper = ({ children }) => {
  return (
    <div className="image_cropper__photo h-100" aria-label="Resize Image">
      {children}
    </div>
  );
};

ImageCropper.propTypes = {
  style: PropTypes.shape({
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  imageSrc: PropTypes.string,
  photo: UploadedPhoto,
  curCrop: PropTypes.shape({
    width: PropTypes.oneOfType([PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.number]),
  }),
  handleCropperZoom: PropTypes.func.isRequired,
  handleCrop: PropTypes.func.isRequired,
  cropperRef: PropTypes.func.isRequired,
};

ImageCropper.defaultProps = {
  imageSrc: null,
  photo: null,
  curCrop: null,
};
